import { ProviderConfig, ProviderTypes } from 'types';
import { DefaultTheme } from 'config/themes';

export const GoogleFiber: ProviderConfig = {
  providerType: ProviderTypes.LEC,
  providerCode: 'google_fiber',
  dcCode: 'google_fiber',
  name: 'GoogleFiber',
  displayName: 'Google Fiber',
  reskinTheme: DefaultTheme,
  reskinTitle: 'Google Fiber Internet',
  showPricingDisclaimer: false,
  broadbandDisplayType: 'linkout_url',
};
